<template>
  <div class="munePage clearfix"
       :class="langFlag ?'enPage':''">

    <div class="munePage_lf">
      <i class="close_ico"
         @click="closeMu"></i>
      <span class="langrg"
            @click='changeLang()'>{{lang}}</span>
      <div class="muecon">
        <div class="mueItem"
             :class="muneIndex==0?'active':''"
             @mouseover="showPic1()"
             @mouseout="hidePic1()">
          <p class="mueItem_p fontS"
             @click="toAbout()">{{langFlag ?'ABOUT':'关于合恣' }} </p>
        </div>
        <div class="mueItem"
             :class="muneIndex==1?'active':''"
             @mouseover="showPic2()"
             @mouseout="hidePic2()">
          <p class="mueItem_p fontS"
             @click="muneChange(1)">{{langFlag ?'PROJECTS':'作品案例' }} </p>
          <ul class="mueItem_ul"
              v-show="muneIndex==1">
            <li class="mueItem_li"
                v-for="(item,index) in muList"
                :key="'mu'+index"
                @click="Tosysj(item.id)">{{item.title}}</li>
            <!-- <li class="mueItem_li"
                @click="Tojdsj(1)">酒店设计</li>
            <li class="mueItem_li"
                @click="Tozzsj(2)">住宅设计</li> -->
          </ul>
        </div>
        <div class="mueItem"
             :class="muneIndex==2?'active':''"
             @mouseover="showPic3()"
             @mouseout="hidePic3()">
          <p class="mueItem_p fontS"
             @click="Torz(2)">{{langFlag ?'JOURNAL':'日志' }}</p>
        </div>
        <div class="mueItem"
             v-show="pcFlag"
             @mouseover="showPic4()"
             @mouseout="hidePic4()"
             :class="muneIndex==3?'active':''">
          <p class="mueItem_p fontS"
             @click="muneChange(3)">{{langFlag ?'CONTACT':'联系合恣' }}</p>
        </div>
        <div class="mueItem"
             v-show="wapFlag"
             :class="muneIndex==3?'active':''">
          <p class="mueItem_p fontS"
             @click="muneChange(3)">{{langFlag ?'CONTACT':'联系合恣' }}</p>
        </div>
      </div>
      <!-- <div class="muecon ywPage">
        <div class="mueItem"
             :class="muneIndex==0?'active':''">
          <p class="mueItem_p "
             @click="toAbout()">ABOUT</p>
        </div>
        <div class="mueItem"
             :class="muneIndex==1?'active':''">
          <p class="mueItem_p"
             @click="muneChange(1)">PROJECTS</p>
          <ul class="mueItem_ul"
              v-show="muneIndex==1">
            <li class="mueItem_li"
                @click="Tosysj(0)">Commercial</li>
            <li class="mueItem_li"
                @click="Tojdsj(1)">Hotel & Resort</li>
            <li class="mueItem_li"
                @click="Tozzsj(2)">Residential</li>
          </ul>
        </div>
        <div class="mueItem"
             :class="muneIndex==2?'active':''">
          <p class="mueItem_p"
             @click="Torz(2)">JOURNAL</p>
        </div>
        <div class="mueItem"
             :class="muneIndex==3?'active':''">
          <p class="mueItem_p"
             @click="muneChange(3)">CONTACT</p>
        </div>
      </div> -->
      <div class="mue_bt ">
        <p class="mue_bt_p">{{langFlag ?'Hezi Design':'上海总部 '}}</p>
        <p class="ft_p3">{{mzaddress}}</p>
        <p class="ft_p3">{{mzybCode}}</p>
        <p class="ft_p4">{{mztel}}</p>
        <p class="ft_p3">{{mzemail}}</p>
      </div>
      <!-- <div class="mue_bt ywPage">
        <p class="mue_bt_p">Hezi Design</p>
        <p class="ft_p3"> Design
          Room 301 North Building 6,<br>No.353, Guiping Road, Xuhui District,</p>
        <p class="ft_p3">Shanghai, China, 200233</p>
        <p class="ft_p4">+86 19514619846</p>
        <p class="ft_p3">hello@hezi-design.com</p>
      </div> -->
    </div>
    <div class="munePage_rg">
      <div class="mergItem"
           v-show="muneIndex!=3">
        <div class="mefm wapmuf">
          <transition name="fade">
            <img src="~@/assets/images/rg_pic.jpg"
                 class="rg_pic"
                 v-show="muneIndexNew==-1" />
          </transition>
          <transition name="fade">
            <img src="~@/assets/images/abouttt.jpg"
                 class="rg_pic"
                 v-show="muneIndexNew==0" />
          </transition>
          <transition name="fade">
            <img src="~@/assets/images/zuooo.jpg"
                 class="rg_pic"
                 v-show="muneIndexNew==1" />
          </transition>
          <transition name="fade">
            <img src="~@/assets/images/riz.jpg"
                 class="rg_pic"
                 v-show="muneIndexNew==2" />
          </transition>

        </div>
      </div>
      <div class="nueCont mergItem"
           v-show="muneIndexNew==3">
        <p class="cont_p1 zwPage fontS">联系我们</p>
        <p class="cont_p2 zwPage">请填写您的咨询信息，收到信息后我们会第一时间安排顾问与您联系。</p>
        <p class="cont_p1 ywPage fontS">Let’s Talk</p>
        <p class="cont_p2 ywPage">For new project inquiries, please tell me a little about<br>
          yourself and your project and I’ll get back to you shortly</p>
        <div class="nueCont_in">
          <div class="nueCont_form">
            <p class="cont_na ">{{langFlag ?'Name':'姓名' }}</p>
            <input type=" text"
                   value=""
                   placeholder=""
                   v-model="name"
                   class="cont_inp" />
          </div>
          <div class="nueCont_form">
            <p class="cont_na">{{langFlag ?'Email':'电子邮件' }}</p>
            <input type=" text"
                   value=""
                   placeholder=""
                   v-model="email"
                   class="cont_inp" />
          </div>
          <div class="nueCont_form">
            <p class="cont_na ">{{langFlag ?'Subject':'主题' }}</p>
            <input type=" text"
                   value=""
                   placeholder=""
                   v-model="theme"
                   class="cont_inp" />
          </div>
          <div class="nueCont_form">
            <p class="cont_na ">{{langFlag ?'Message':'信息' }}</p>
            <textarea type=" text"
                      value=""
                      placeholder=""
                      v-model="information"
                      class="cont_area"></textarea>
          </div>
          <div class="mut_bt">
            <button class="tjxx"
                    @click="sendMessage">{{langFlag ?'Submit':'提交' }}</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
import { WOW } from 'wowjs'
import foot from '@/components/foot.vue'
import gotop from '@/components/goTop.vue'
import { mapMutations, mapGetters, mapState } from 'vuex'
import { isCardName, isEmailAvailable } from '@/untils/tool.js'
import { Toast } from 'vant'

export default {
  data() {
    return {
      wapFlag: false,
      pcFlag: false,
      DesignIndex: -1,
      name: '',
      email: '',
      theme: '',
      information: '',
      designShow: false,
      muList: [],
      mzname: '',
      mzaddress: '',
      mzemail: '',
      mztel: '',
      mzybCode: '',
      muneIndexNew: '',
      screenWidth: 0,
      timer: false,
    }
  },
  components: { foot },
  props: ['muneFlag', 'muneIndex'],
  created() {},
  beforeRouteLeave(to, from, next) {},
  beforeDestroy() {},

  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }

    if (this.screenWidth > 750) {
      this.wapFlag = false
      this.pcFlag = true
    } else {
      this.wapFlag = true
      this.pcFlag = false
    }

    this.muneIndexNew = this.muneIndex
    console.log('数字www', this.muneIndex, this.muneIndexNew)

    this.settings()
    this.projectCate()
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false,
      })
      wow.init()
    })
  },
  computed: {
    ...mapState(['langFlag', 'lang']),
  },

  watch: {
    langFlag(val) {
      console.log('中英文的值', val)
      this.settings()
      this.projectCate()
    },
    muneIndex(val) {
      console.log('muneIndex', val)
      this.muneIndexNew = val
    },
    screenWidth(val) {
      console.log('数字2222', val)
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val
        this.timer = true
        let that = this
        setTimeout(function () {
          // 打印screenWidth变化的值
          console.log('数字', that.screenWidth)
          that.timer = false
          if (val > 750) {
            that.wapFlag = false
            that.pcFlag = true
          } else {
            that.wapFlag = true
            that.pcFlag = false
          }
        }, 400)
      }
    },
  },
  methods: {
    muneChange(index) {
      console.log('ddddddd', index)
      this.$emit('muneChange', index)
      console.log('dfdf', this.muneIndex)
      if (index == 3) {
        this.muneIndexNew = index
      }
      if (index == 1) {
        this.designShow = true
      } else {
        this.designShow = false
      }
    },
    DesignChange(index) {
      this.DesignIndex = index
    },
    closeMu() {
      this.$emit('closeMu', false)
    },
    toAbout() {
      this.$emit('closeMu', false)
      this.$router.push({
        name: 'aboutUs',
        // query: {
        //   type: type,
        // },
      })
      console.log('this.DesignIndex222', this.DesignIndex)
    },
    Tosysj(id) {
      this.$emit('closeMu', id)
      this.$router.push({
        name: 'imageList',
        query: {
          id: id,
        },
      })
    },
    Torz() {
      this.$emit('closeMu', false)
      this.$router.push({
        name: 'journalList',
        // query: {
        //   type: type,
        // },
      })
    },
    //切换语言
    changeLang() {
      // this.SET_WFFLAG(true)
      console.log('语言1', this.langFlag)
      this.$store.commit('setLang', !this.langFlag)
      this.$store.commit('setLa', this.lang == 'EN' ? 'CH' : 'EN')
      console.log('语言', this.langFlag)
    },
    // 获取网站配置
    settings() {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'settings',
        that.$qs.stringify({
          type: type,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            let info = response.data
            response.data.forEach(function (item) {
              if (item.code == 'WEB_PIC1') {
                //"首页位置1"
              } else if (item.code == 'WEB_PIC2') {
                //"首页位置2"
              } else if (
                item.code == 'WEB_TITLE' ||
                item.code == 'WEB_TITLE_EN'
              ) {
                //网站标题"
                that.mzname = item.value
              } else if (
                item.code == 'WEB_ADDRESS' ||
                item.code == 'WEB_ADDRESS_EN'
              ) {
                //联系地址
                that.mzaddress = item.value
              } else if (
                item.code == 'WEB_EMAIL' ||
                item.code == 'WEB_EMAIL_EN'
              ) {
                //"电子邮件"
                that.mzemail = item.value
              } else if (
                item.code == 'WEB_PHONE' ||
                item.code == 'WEB_PHONE_EN'
              ) {
                //联系电话"
                that.mztel = item.value
              } else if (
                item.code == 'WEB_CODE' ||
                item.code == 'WEB_CODE_EN'
              ) {
                //邮编"
                that.mzybCode = item.value
              }
            })
          }
        })
        .catch(function (error) {})
    },
    // 获取产品分类
    projectCate() {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'projectCate',
        that.$qs.stringify({
          type: type,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            that.muList = response.data
          }
        })
        .catch(function (error) {})
    },
    // 联系我们
    sendMessage() {
      if (!isCardName(this.name)) {
        this.$toast('请输入正确的姓名')
        return false
      }
      if (!isEmailAvailable(this.email)) {
        this.$toast('请输入正确的电子邮箱')
        return false
      }
      if (this.theme.length == 0) {
        this.$toast('请输入主题')
        return false
      }
      if (this.information.length == 0) {
        this.$toast('请输入信息')
        return false
      }

      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'sendMessage',
        that.$qs.stringify({
          type: type,
          name: that.name,
          email: that.email,
          subject: that.theme,
          content: that.information,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            Toast('提交成功~')
            that.name = ''
            that.email = ''
            that.theme = ''
            that.information = ''
          }
        })
        .catch(function (error) {})
    },
    showPic1() {
      this.muneIndexNew = 0
    },
    hidePic1() {
      this.muneIndexNew = this.muneIndex
    },
    showPic2() {
      this.muneIndexNew = 1
    },
    hidePic2() {
      this.muneIndexNew = this.muneIndex
    },
    showPic3() {
      this.muneIndexNew = 2
    },
    hidePic3() {
      this.muneIndexNew = this.muneIndex
    },
    showPic4() {
      this.muneIndexNew = 3
    },
    hidePic4() {
      this.muneIndexNew = this.muneIndex
    },
  },
}
</script>






// WEBPACK FOOTER //
// src/pages/munePage.vue